import styled from 'styled-components';
import { colors, typography } from '../../../lib/styles';
import getHighContrastTextColor from '../../../lib/getHighContrastTextColor';

export const ControlsIcon = styled.div<{ isOpen: boolean; featureColor?: string; color?: string }>`
    display: inline-block;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: ${typography.typeScale.size5}px;
    color: ${({ color, featureColor }) =>
        color ? color : featureColor ? getHighContrastTextColor(featureColor) : colors.grey800};

    &:before {
        display: block;
        margin: 0;
        line-height: 1;
    }
`;
